import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDateFormat]'
})
export class DateFormatDirective {

  constructor(private el: ElementRef) {
    this.el.nativeElement.placeholder = "mm/dd/yyyy";
  }

  isIE() {
    const agent = window.navigator.userAgent.toLowerCase();
    return agent.indexOf('trident') > -1;
  }

  @HostListener('input', ['$event']) onInputChange(event: KeyboardEvent) {
    let input = this.el.nativeElement.value;
    input = input.replace(/[^0-9\/-]/g, '');
    const formattedInput = input.replace(/-/g, '/');

    if (this.isValidDate(formattedInput)) {
      this.el.nativeElement.value = formattedInput;
    } else {
      this.el.nativeElement.value = formattedInput.slice(0, -1);
    }

    this.el.nativeElement.value = formattedInput;
  }

  private isValidDate(dateString: string): boolean {
    const datePattern = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
    const match = dateString.match(datePattern);

    if (!match) {
      return false;
    }

    const month = parseInt(match[1], 10);
    const day = parseInt(match[2], 10);
    const year = parseInt(match[3], 10);

    // Basic validation for month, day, and year
    if (month < 1 || month > 12) {
      return false;
    }

    if (day < 1 || day > 31) {
      return false;
    }

    // Handle month-specific day limits
    if ((month === 4 || month === 6 || month === 9 || month === 11) && day > 30) {
      return false;
    }

    // February check (including leap year)
    if (month === 2) {
      const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
      if (day > (isLeapYear ? 29 : 28)) {
        return false;
      }
    }

    return true;
  }
}
